import { File, FileNameTypes, FileUploadStatus, ReportDetailsQuery } from '@/__generated__/graphql';
import { SelectableImage } from '../SelectableImage';
import { getCloudfrontUrl } from '@/utils/cloudfront';
import { Dispatch, SetStateAction, useMemo } from 'react';

type Props = {
  pois: ReportDetailsQuery['report']['pointOfInterests'];
  reportFiles: ReportDetailsQuery['report']['files'];
  setImagesToDetach: Dispatch<SetStateAction<string[]>>;
  imagesToDetach: string[];
};
export const AttachedImages = ({ imagesToDetach, setImagesToDetach, pois, reportFiles }: Props) => {
  const allPoiImages = useMemo(() => {
    const attachments: File[] = (pois ?? [])?.flatMap((poi) => {
      return (poi.files ?? [])?.filter(({ uploadStatus, name }) => {
        if (uploadStatus !== FileUploadStatus.Success) return false;
        return name === FileNameTypes.PoiAttachments;
      });
    });

    return attachments;
  }, [pois]);

  return (
    <>
      {(reportFiles || [])
        .filter((file) =>
          allPoiImages.some((poiImage) => poiImage.resourcePath === file.resourcePath)
        )
        .map((file, index) => {
          return (
            <div style={{ display: 'flex', flexWrap: 'wrap' }} key={`${file.id}-${index}`}>
              <SelectableImage
                imgProps={{
                  src: getCloudfrontUrl(file.resourcePath),
                  width: '100%',
                }}
                overlayVisible={Boolean(!imagesToDetach?.includes(file.id ?? ''))}
                onClick={() => {
                  setImagesToDetach((prev) => {
                    const imageIndex = prev.indexOf(file.id ?? '');
                    if (imageIndex === -1) {
                      return [...prev, file.id ?? ''];
                    }
                    return prev.filter((_, i) => i !== imageIndex);
                  });
                }}
              />
            </div>
          );
        })}
    </>
  );
};
